module.exports = __webpack_public_path__ + "static/img/info.536a911.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/info.png
// module id = pn87
// module chunks = 1